import React, { useEffect, useState } from "react";
import "./kzen8-for-industry-experts.scss";
import { FcRefresh, FcSettings, FcRuler } from "react-icons/fc";
import LazyLoad from "react-lazyload";
import { useWindowSize } from "@react-hook/window-size/throttled";
import { Button } from "@mui/material";
import { BsFillArrowRightCircleFill } from "react-icons/bs";
import { Link } from "react-router-dom";
import { IoChatbox } from "react-icons/io5";

const Kzen8ForIndustryExperts = () => {

  const [width, height] = useWindowSize();
  const [playerSize, setPlayerSize] = useState("768px");

  useEffect(() => {
    if (width > 1420) {
      setPlayerSize("512px");
    }
    else if (width > 720) {
      setPlayerSize("420px");
    } else {
      setPlayerSize("320px");
    }

  }, [width]);

  return (
    <div className="sectionContainer kzen8ForIndustryExperts full-width-element">
      <div className="leftSection">
      {/* <svg id="sw-js-blob-svg" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">                    <defs>                         <linearGradient id="sw-gradient" x1="0" x2="1" y1="1" y2="0">                            <stop id="stop1" stop-color="rgba(53, 162, 159, 1)" offset="0%"></stop>                            <stop id="stop2" stop-color="rgba(7, 25, 82, 1)" offset="100%"></stop>                        </linearGradient>                    </defs>                <path fill="url(#sw-gradient)" d="M13,-21.9C15,-18.9,13.6,-12.2,18,-6.9C22.4,-1.6,32.7,2.3,34.8,6.7C36.8,11.2,30.7,16.2,24.8,19.4C18.8,22.6,13.1,24,8.3,22.9C3.5,21.8,-0.4,18.3,-7.8,19.4C-15.1,20.5,-25.9,26.1,-31.5,24.6C-37,23,-37.3,14.2,-33.1,8C-28.9,1.8,-20.2,-1.7,-16.1,-6C-12.1,-10.3,-12.5,-15.3,-10.6,-18.3C-8.7,-21.4,-4.3,-22.5,0.6,-23.4C5.5,-24.3,10.9,-24.9,13,-21.9Z" width="100%" height="100%" transform="translate(50 50)" style={{transition: '0.3s'}} stroke-width="0"></path>              </svg> */}
      <video src="/videos/Kzen8 Gold Coast Health Nursing Student Placements Made Easy.mp4" autoPlay="true" playsInline="true" muted="false" controls alt="Kzen8 - Partner Expert">
      </video>
       
      
      </div>
      <div className="rightSection">
      <h1 className="bigHeading">Complete Nursing Placements
          Solution</h1>

        <div className="subtitle1 paragraph">
          <strong style={{ fontWeight: 900 }}>Frictionless Nursing Placements</strong>
          The Kzen8 Nursing platform automates and
          streamlines nursing student allocations in the
          GCHHS. This manages the process end to end
          from the Student Deed, pre orientation checklists,
          capacity management, cancellations, and finance
          reporting.    <br></br>
          <br></br>
          {/* <Link to="/contact-us">
            <Button className="btn btn-tertiary callToAction subtitle2" variant="contained" endIcon={<IoChatbox />}>
              Let's chat
            </Button>
          </Link> */}
        </div>
      </div>

      {/* <ul className="stepList">
                <LazyLoad>
                    <li className="body slideUpAnimation animated initially-hidden">
                        <h3 className='header primary-text-colour'>Step 1: Prioritise </h3>
                        <lottie-player
                            src="/lottie-files/plan.json"
                            // src="https://assets7.lottiefiles.com/packages/lf20_ep20cd8e.json"
                            background="transparent"
                            speed="1"
                            style={{ width: 300, height: 300 }}
                            autoplay
                            loop
                        ></lottie-player>
                        Working with key stakeholders, map out the requirements identifying and prioritising areas where the Kzen8 platform quickly adds the most value.</li>
                </LazyLoad>
                <LazyLoad>
                    <li className="body slideUpAnimation animated initially-hidden delay-1-quarter">
                        <h3  className='header primary-text-colour'>Step 2: Build and embed</h3>
                        <lottie-player
                            src="/lottie-files/build-2.json"
                            // src="https://assets7.lottiefiles.com/packages/lf20_ep20cd8e.json"
                            background="transparent"
                            speed="1"
                            style={{ width: 300, height: 300 }}
                            autoplay
                            loop
                        ></lottie-player>
                        Using the Kzen8 platform deliver a solution over a series of short itterations, typically between 2 and 5 days each.
                        <br></br><br></br>Release each itteration to end users to ensure the solution meets their needs and the new systems and processes are fully adopted into their day to day operations.
                    </li>
                </LazyLoad>
                <LazyLoad>
                    <li className="body slideUpAnimation animated initially-hidden delay-1-half">
                        <h3  className='header primary-text-colour'>Step 3: Repeat</h3>
                        <lottie-player
                            src="/lottie-files/infinity.json"
                            background="transparent"
                            speed="1"
                            style={{ width: 300, height: 300 }}
                            autoplay
                            loop
                        ></lottie-player>
                        Once the solution from step 2 is fully embedded in the business, loop back to step 1 to review overall priorities and address the next priority as required.
                    </li>
                </LazyLoad>
            </ul> */}
    </div>
  );
};

export default Kzen8ForIndustryExperts;
